import React, { createElement, Fragment } from 'react';
import ProCard from '@/components/layout/pro-card';
import { Field, Table, Form, Tag, Button, ResponsiveGrid, Input, Select, TreeSelect } from '@alifd/next';
import request from '@/utils/request';
import { drop, isEmpty } from 'lodash-es';
import { nanoid } from 'nanoid';
import ServiceTable from './service-table';
import { useAsyncEffect } from 'ahooks';
import ServiceOutTable from './service-out-table';
const AccountingEventServiceCall = (props) => {
    const [dataSource, setDataSource] = React.useState([]);
    const [jsonSchemaTreeData, setJsonSchemaTreeData] = React.useState([]);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
    const editTableRef = React.useRef();
    const [dataSrcCdType, setDataSrcCdType] = React.useState('');
    const [serviceUid, setServiceUid] = React.useState('');
    const [serviceId, setServiceId] = React.useState('');
    const [showService, setShowService] = React.useState(false);
    const [showResService, setShowResService] = React.useState(false);
    const [serviceNameContent, setServiceNameContent] = React.useState([]);
    const [resdataSource, setResDataSource] = React.useState([]);
    const [outDataSource, setOutDataSource] = React.useState([]);
    const formItemsCall = [
        {
            componentName: 'CbayelFormApiSelect',
            primaryKey: nanoid(),
            label: '服务配置名称',
            size: 'medium',
            fullWidth: true,
            columnSpan: 1,
            isShowInColumn: true,
            name: 'serviceId',
            required: true,
            componentProps: {
                placeholder: '请输入',
                size: 'medium',
                hasClear: false,
                showSearch: false,
                hasArrow: true,
                type: "ACCT_SERVICE_LIST",
                paramsMap: []
            },
            type: 'dict',
            dictData: serviceNameContent
        }
    ];
    const queryList = React.useCallback(async () => {
        const { content = [] } = await request.get('/api/account/service/summary');
        const data = content?.map(({ name, code, entityCode, id, resEntityCode }) => {
            return {
                label: `${name}(${code})`,
                value: id,
                entityCode,
                id,
                resEntityCode
            };
        });
        setServiceNameContent(data);
    }, []);
    React.useEffect(() => {
        queryList();
    }, [queryList]);
    const formField = Field.useField({
        parseName: true,
    });
    const { blockProps, field, formProps, __designMode, listName, changingField, serviceCall = [], mapName, title, editType } = props;
    const { columns, spacing, primaryKey = 'uid', status } = formProps;
    const isPreview = status === 'readonly' || editType === 'view';
    const isDesign = __designMode === 'design';
    const targetParamcode = field.getValue('accountEntityCode');
    const columnsTable = [
        {
            title: '服务配置实体属性',
            dataIndex: 'targetParam',
            width: 300,
        },
        {
            title: '数据来源',
            dataIndex: 'dataSrcCd',
            width: 300,
            cell: (val) => {
                const dataSrcCdEnums = {
                    '900800000040': '源请求实体参数',
                    '900800000030': '上下文参数',
                    '900800000050': '固定值'
                };
                return createElement("span", null, dataSrcCdEnums[val]);
            }
        },
        {
            title: '数据对象',
            dataIndex: 'sourceParam',
            width: 300,
        },
    ];
    const queryReplaceData = (data = []) => {
        const replaceData = data.map(item => {
            const { sourceParam } = item;
            if (!isEmpty(sourceParam)) {
                const replaceValue = sourceParam.replace('{}', '').replace(/({\w+})/, (match) => {
                    const index = match.slice(1, -1);
                    return `[].${index}`;
                });
                return {
                    ...item,
                    sourceParam: replaceValue
                };
            }
            return item;
        });
        return replaceData;
    };
    const onAcceventcfgServiceSelect = async (val = []) => {
        const serviceId = val?.[0]?.serviceId;
        const { entityCode, resEntityCode } = serviceNameContent?.filter(item => item.id === serviceId)[0] || {};
        const isShow = !isEmpty(entityCode) && !isEmpty(serviceId);
        setShowService(isShow);
        const isResShow = !isEmpty(resEntityCode) && !isEmpty(serviceId);
        setShowResService(isResShow);
        if (!isEmpty(entityCode)) {
            const uid = val?.[0]?.uid;
            setServiceUid(uid);
            setServiceId(val?.[0]?.id);
            const reqServiceMapperList = val?.[0]?.reqServiceMapperList;
            if (!isEmpty(reqServiceMapperList)) {
                const newDataSource = reqServiceMapperList.map(item => ({ ...item, uid: nanoid() }));
                const replaceData = queryReplaceData(newDataSource);
                setDataSource(replaceData);
            }
            else {
                const { content = [] } = await request.get('/api/exchange/entity/schema/analyzing', {
                    params: { entityCd: entityCode },
                });
                const newDataSource = content.map(item => ({ ...item, uid: nanoid() }));
                const replaceData = queryReplaceData(newDataSource);
                setDataSource(replaceData);
            }
            const resServiceMapperList = val?.[0]?.resServiceMapperList;
            if (!isEmpty(resServiceMapperList)) {
                const newDataSource = resServiceMapperList.map(item => ({ ...item, uid: nanoid() }));
                const replaceData = queryReplaceData(newDataSource);
                setResDataSource(replaceData);
            }
            else {
                const { content: resContent = [] } = await request.get('/api/exchange/entity/schema/analyzing', {
                    params: { entityCd: resEntityCode },
                });
                const newResDataSource = resContent.map(item => ({ ...item, _uid: nanoid() }));
                const replaceResData = queryReplaceData(newResDataSource);
                setResDataSource(replaceResData);
            }
        }
    };
    useAsyncEffect(async () => {
        if (!isEmpty(targetParamcode)) {
            const { content: contenttargetParam } = await request(`/api/exchange/entity/extend/${targetParamcode}`);
            const dataObjSchema = contenttargetParam?.bigData?.dataContent || '{}';
            const dataObjData = transformSchema2tree(JSON.parse(dataObjSchema));
            setJsonSchemaTreeData(dataObjData);
        }
    }, [targetParamcode]);
    const resetSelectedRows = () => {
        setSelectedRowKeys([]);
        setSelectedRows([]);
    };
    const cancle = () => {
        resetSelectedRows();
    };
    const onChange = async (val, dataIndex) => {
        const newData = dataSource.map((item = {}) => {
            if (item.uid === selectedRowKeys[0]) {
                const updateItem = { ...item };
                updateItem[dataIndex] = val;
                return updateItem;
            }
            return item;
        });
        const replaceData = queryReplaceData(newData);
        setDataSource(replaceData);
        if (dataIndex === 'dataSrcCd') {
            setDataSrcCdType(val);
            formField.setValue('sourceParam', '');
        }
    };
    const save = () => {
        formField.validate((errors, values) => {
            if (isEmpty(errors)) {
                const newData = dataSource.map((item = {}) => {
                    if (item.uid === selectedRowKeys[0]) {
                        return { ...values };
                    }
                    return item;
                });
                const replaceData = queryReplaceData(newData);
                setDataSource(replaceData);
                resetSelectedRows();
            }
        });
    };
    const submit = () => {
        save();
        const changelist = dataSource.map(item => {
            const newobj = { ...item };
            serviceCall.forEach(eve => {
                const { name, refValue } = eve || {};
                newobj[refValue] = item[name];
            });
            return newobj;
        });
        setDataSource(changelist);
        const accEventServiceCfgList = field.getValue('accEventServiceCfgList') ?? [];
        const updateAccEventServiceCfgList = accEventServiceCfgList.map(item => {
            if (serviceId === item.id || serviceUid === item.uid) {
                return {
                    ...item,
                    reqServiceMapperList: changelist,
                    resServiceMapperList: outDataSource
                };
            }
            return item;
        });
        field.setValue('accEventServiceCfgList', updateAccEventServiceCfgList);
        resetSelectedRows();
    };
    const getOutTableValue = (val) => {
        setOutDataSource(val);
    };
    const onRowChange = (selectedRowKey, records) => {
        setSelectedRowKeys(selectedRowKey);
        setSelectedRows(records);
        const { sourceParam, dataSrcCd } = records[0] || {};
        formField.setValues({
            ...records[0],
            sourceParam: sourceParam ?? '',
            dataSrcCd: dataSrcCd ?? '',
        });
    };
    const rowSelection = {
        mode: 'single',
        onChange: onRowChange,
        selectedRowKeys,
        getProps: () => {
            return {
                disabled: isDesign || isPreview,
            };
        },
    };
    return (createElement(Fragment, null,
        createElement(ProCard, { ...blockProps, title: title },
            createElement(ServiceTable, { field: field, listName: 'accEventServiceCfgList', __designMode: __designMode, formProps: formProps, getHandler: (handler) => {
                    editTableRef.current = handler;
                }, changingField: changingField, getSelectRow: onAcceventcfgServiceSelect, editType: editType }, formItemsCall)),
        showService && (createElement(ProCard, { ...blockProps, title: '\u670D\u52A1\u5165\u53C2\u6620\u5C04' },
            createElement("div", null,
                createElement(Table, { dataSource: dataSource, columns: columnsTable, rowSelection: rowSelection, primaryKey: "uid" }),
                ((isDesign || selectedRows.length > 0) && !isPreview) && (createElement(Form, { isPreview: isPreview, field: formField, useLabelForErrorMessage: true, labelAlign: "left", fullWidth: false },
                    createElement(ResponsiveGrid, { gap: spacing, columns: columns },
                        createElement(Form.Item, { labelAlign: "left", label: "\u670D\u52A1\u914D\u7F6E\u5B9E\u4F53\u5C5E\u6027", name: "targetParam", size: "medium", fullWidth: true },
                            createElement(Input, { placeholder: "\u8BF7\u8F93\u5165", size: "medium", disabled: true })),
                        createElement(Form.Item, { labelAlign: "left", label: "\u6570\u636E\u6765\u6E90", name: "dataSrcCd", size: "medium", fullWidth: true, required: true },
                            createElement(Select, { placeholder: "\u8BF7\u9009\u62E9\u6570\u636E\u6765\u6E90", size: "medium", dataSource: [
                                    { label: '源请求实体参数', value: '900800000040' },
                                ], onChange: (val) => onChange(val, 'dataSrcCd') })),
                        createElement(Form.Item, { labelAlign: "left", label: "\u6570\u636E\u5BF9\u8C61", name: "sourceParam", size: "medium", fullWidth: true, required: dataSrcCdType === '900800000040' },
                            createElement(TreeSelect, { placeholder: "\u8BF7\u9009\u62E9\u6570\u636E\u5BF9\u8C61", size: "medium", dataSource: jsonSchemaTreeData, showSearch: true, hasClear: true, onChange: (val) => onChange(val, 'sourceParam') }))),
                    isPreview ? null : (createElement("div", { style: { textAlign: 'center' } },
                        createElement(Button.Group, null,
                            createElement(Button, { type: "primary", key: nanoid(), onClick: submit, disabled: isDesign }, "\u4FDD\u5B58"),
                            createElement(Button, { onClick: cancle }, "\u53D6\u6D88"))))))))),
        showResService && (createElement(ServiceOutTable, { data: resdataSource, isPreview: isPreview, blockProps: blockProps, isDesign: isDesign, spacing: spacing, columns: columns, jsonSchemaTreeData: jsonSchemaTreeData, field: field, getOutTable: getOutTableValue, serviceId: serviceId, serviceUid: serviceUid, reqServiceMapperList: dataSource }))));
};
export default AccountingEventServiceCall;
const transformSchema2tree = (schema = {}) => {
    if (!schema) {
        return [];
    }
    const { properties, type, items, pathPrefix = 'properties', dataPrefix = 'properties', parentType = 'object', parentDataPrefix = null, rootType = null, level = 0, } = schema;
    if (type === 'object') {
        const data = Object.keys(properties).map((key) => {
            const el = properties[key];
            const { type, description = '', required = false, dict, dataSourceType, } = el;
            const _pathKey = [].concat(pathPrefix, key, 'properties').join('.');
            const _dataKey = [].concat(dataPrefix, type === 'array' ? `${key}[]` : key).join('.');
            const _parentdataKey = [].concat(dataPrefix, key).join('.');
            const options = {
                ...el,
                pathPrefix: _pathKey,
                dataPrefix: _dataKey,
                parentType: type,
                parentDataPrefix: _parentdataKey,
                rootType: type,
                level: level + 1,
                dataSourceType,
            };
            const children = transformSchema2tree(options).length === 0 ? null : transformSchema2tree(options);
            const label = () => {
                let color = 'blue';
                if (type !== 'object' || type !== 'array') {
                    color = 'green';
                }
                const title = isEmpty(description) ? `${key}` : `${key}(${description})`;
                return (createElement("div", { style: { display: 'flex' } },
                    createElement("div", { style: { marginRight: 8, fontWeight: 'bold' } }, title),
                    createElement("div", null,
                        createElement(Tag, { type: "primary", size: "small", color: color }, type))));
            };
            const value = drop(_dataKey.split('.')).join('.');
            return {
                key: _pathKey,
                type,
                name: key,
                required,
                description,
                parentKey: pathPrefix,
                parentType,
                dataKey: _dataKey,
                dict,
                parentDataPrefix,
                rootType: rootType || type,
                level,
                dataSourceType,
                label: label(),
                value,
                children,
            };
        });
        return data;
    }
    else if (type === 'array') {
        const arrayPrefix = pathPrefix.split('.');
        arrayPrefix.pop();
        const finalPrefix = [].concat(arrayPrefix, 'items', 'properties').join('.');
        return transformSchema2tree({
            ...items,
            pathPrefix: finalPrefix,
            dataPrefix,
            parentType,
            parentDataPrefix,
            rootType,
            level,
        });
    }
    return [];
};
const flatList = (data = []) => {
    return data.reduce((pre, cur) => {
        const { children = [], ...i } = cur;
        if (children && !isEmpty(children)) {
            return pre.concat([{ ...i }], flatList(children));
        }
        return pre.concat([{ ...i }]);
    }, []);
};
